export function operacaoBloqueioVeiculoPreFaturasInRequest(params = {}) {
  return {
    type: '@operacaobloqueioveiculoprefaturas/RADAPROVARPREFATURA_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoBloqueioVeiculoPreFaturas(fatu_codigo) {
  return {
    type: '@operacaobloqueioveiculoprefaturas/FIND_RADAPROVARPREFATURA',
    payload: { fatu_codigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaobloqueioveiculoprefaturas/FAILED_REQUEST',
  };
}

export function deleteOperacaoBloqueioVeiculoPreFaturas(fatu_codigo, params) {
  return {
    type: '@operacaobloqueioveiculoprefaturas/DELETE_RADAPROVARPREFATURA',
    payload: { fatu_codigo, params },
  };
}

export function updateOperacaoBloqueioVeiculoPreFaturas(
  operacaobloqueioveiculoprefaturas,
  params
) {
  return {
    type: '@operacaobloqueioveiculoprefaturas/UPDATE_RADAPROVARPREFATURA',
    payload: { operacaobloqueioveiculoprefaturas, params },
  };
}

export function storeOperacaoBloqueioVeiculoPreFaturas(
  operacaobloqueioveiculoprefaturas,
  params
) {
  return {
    type: '@operacaobloqueioveiculoprefaturas/STORE_RADAPROVARPREFATURA',
    payload: { operacaobloqueioveiculoprefaturas, params },
  };
}

export function successInRequest(
  operacaobloqueioveiculoprefaturas,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaobloqueioveiculoprefaturas/SUCCESS_IN_REQUEST',
    payload: {
      operacaobloqueioveiculoprefaturas,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function successRequest(operacaobloqueioveiculoprefaturas) {
  return {
    type: '@operacaobloqueioveiculoprefaturas/SUCCESS_REQUEST',
    payload: { operacaobloqueioveiculoprefaturas },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaobloqueioveiculoprefaturas/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaobloqueioveiculoprefaturas/RECORD_FILTERING',
    payload: { params },
  };
}
